import type { Command, CommandId } from '@/types';
import { asCommandId } from '@/types';
import { createId } from '@/utils/id';

export interface CommandSpec<S> {
  readonly name: string;
  readonly label: string;
  readonly execute: (state: S) => S;
  readonly undo: (state: S) => S;
  readonly merge?: (next: Command<S>) => Command<S> | null;
  readonly id?: CommandId;
}

/** Small factory so features do not have to hand-roll ids and shape. */
export const createCommand = <S>(spec: CommandSpec<S>): Command<S> => {
  const command: Command<S> = {
    id: spec.id ?? asCommandId(createId('cmd')),
    name: spec.name,
    label: spec.label,
    execute: spec.execute,
    undo: spec.undo,
  };
  if (spec.merge) return { ...command, merge: spec.merge };
  return command;
};
